import _escape from 'lodash/escape'

export const permissionHelper = (checkResult, next, config = null, errorMessage = 'Недостаточно прав.') => {
  if (checkResult) {
    config ? next(config) : next()
  } else {
    window.fpm.$appToast.error(errorMessage, 'Ошибка авторизации!')
  }
}

export const isLeadingMonth = () => {
  const month = 11
  const date = new Date(2020, month, 31)
  const strDate = date.toLocaleDateString()
  return strDate.indexOf((month + 1).toString()) === 0
}

export const localeDateFormat = () => {
  const month = 11
  const date = new Date(2020, month, 31)
  let strDate = date.toLocaleDateString()
  strDate = strDate.replace('31', 'DD')
  strDate = strDate.replace('12', 'MM')
  strDate = strDate.replace('2020', 'YYYY')
  return strDate
}

export const localeTimeFormat = () => {
  const hour = 23
  const date = new Date(2020, 12, 31, hour, 55)
  let strTime = date.toLocaleTimeString()
  if (strTime.indexOf(hour.toString()) === 0) {
    return 'HH:mm'
  }
  return 'hh:mm A'
}

export const isNumeric = (n) => {
  return !isNaN(parseFloat(n)) && isFinite(n)
}

export const getAuthHeader = () => {
  let user = window.fpm.$store.state.auth.user
  if (user) {
    return { Authorization: `Basic ${btoa(user.token + ':')}` }
  }
}

const LINK_LEN = 35

/**
 * Replace all http uri matches to <a> tag in text
 * @param text
 * @returns {*}
 */
const textAddLink = (text) => {
  return text.replace(/\bhttps?:\/\/\S+/gi, (match) => {
    let linkText = `${match.slice(0, LINK_LEN)}${match.length > LINK_LEN ? '...' : ''}`
    return `<a href="${match}" title="${match}" target="_blank">${linkText}</a>`
  })
}

const textAddBr = (text) => {
  return text.replace(/\n/g, '<br>')
}

export const textToHtmlConverter = (text) => {
  text = _escape(text)
  text = textAddBr(text)
  text = textAddLink(text)
  return text
}

/**
 * Convert ArrayBuffer to String
 * @param buffer
 * @returns {string}
 */
export const bufferToStr = (buffer) => {
  let str = ''
  let bytes = new Uint8Array(buffer)
  let len = bytes.byteLength
  for (let i = 0; len > i; i++) {
    str += String.fromCharCode(bytes[i])
  }

  return str
}

/**
 * Convert String to ArrayBuffer
 * @param str
 * @returns {ArrayBuffer}
 */
export const strToBuffer = (str) => {
  let strLen = str.length
  let buffer = new ArrayBuffer(strLen * 2)
  let view = new Uint8Array(buffer)
  for (let i = 0; strLen > i; i++) {
    view[i] = str.charCodeAt(i)
  }

  return buffer
}

/**
 * Extract third level fragment from string
 * @param url string
 * @return string|boolean third level domain if found, empty string if it's just 2-nd level domain, false otherwise
 */
export const getThirdLevelDomain = (url) => {
  let parser = document.createElement('a')
  parser.href = url
  let hostParts = parser.hostname.split('.')
  if (hostParts.length === 3) {
    return hostParts[0]
  } else if (hostParts.length === 2) {
    return ''
  }
  return false
}

export const convertServerErrors = (serverErrors) => {
  let convertedErrors = {}
  serverErrors.forEach((error) => {
    if (!convertedErrors[error.field]) {
      convertedErrors[error.field] = []
    }
    convertedErrors[error.field].push(error.message)
  })

  return convertedErrors
}

export const getAvatarSrc = (id = '', timestamp = '', defaultSrc = '/img/points/icon-user-normal.svg') => {
  return id ? `/api/v1/img/avatars/${id}.jpg?timestamp=${timestamp}` : defaultSrc
}

export function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

export function downloadFile(content, fileName = 'file') {
  const blob = new Blob([content], { type: 'text/plain' })
  const a = document.createElement('a')
  a.href = URL.createObjectURL(blob)
  a.download = fileName

  document.body.appendChild(a)

  a.click()

  setTimeout(() => {
    document.body.removeChild(a)
    window.URL.revokeObjectURL(a.href)
  }, 100)
}
